import axios from 'axios';
import {
  IBuyerCityCollection,
  IBuyerCityListParams,
  IDelivery,
  IDeliveryCollection,
  IDeliveryListParams,
  // TODO FIX after api package is updated
  // ICreateDeliveryPayload,
  // IDeleteDeliveryPayload,
  // IUpdateDeliveryPayload,
} from 'entities/Delivery/Delivery.models';

const basePath = 'delivery';

export const deliveryTransport = {
  get: (params: IDeliveryListParams): Promise<IDeliveryCollection> => axios.get(`${basePath}`, { params }),
  // TODO FIX after api package is updated
  create: (payload: any): Promise<IDelivery> => axios.post(`${basePath}`, payload),
  update: (payload: any): Promise<IDelivery> => axios.patch(`${basePath}`, payload),
  delete: (payload: any): Promise<IDelivery> => axios.delete(`${basePath}`, { data: payload }),
  getBuyerCities: (params: IBuyerCityListParams): Promise<IBuyerCityCollection> =>
    axios.get(`${basePath}/buyer-cities`, { params }),
};
